/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspaid1Inputs */

const en_earningspaid1 = /** @type {(inputs: Earningspaid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid out`)
};

const de_earningspaid1 = /** @type {(inputs: Earningspaid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgezahlt`)
};

/**
* | output |
* | --- |
* | "Paid out" |
*
* @param {Earningspaid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspaid1 = /** @type {((inputs?: Earningspaid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspaid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspaid1(inputs)
	return de_earningspaid1(inputs)
});
export { earningspaid1 as "earningsPaid" }